app.factory("RemindersService", ["$http",
    function ($http) {
        var RemindersService = {};

        RemindersService.list = function (params) {
            params = params || {};
            params.limit = params.limit || 10;
            params.page = params.page || 1;
            return $http.get("/reminder", {
                params: params
            }).then(function (resp) {
                return resp.data;
            });
        };

        RemindersService.create = function (reminder) {
            return $http.post("/reminder", reminder).then(function (resp) {
                return resp.data;
            });
        };

        RemindersService.markAsRead = function (reminderId) {
            return $http.post("/reminder/read", {reminderId: reminderId}).then(function (resp) {
                return resp.data;
            });
        };

        RemindersService.delete = function (reminderId) {
            return $http.delete('/reminder/' + reminderId).then(function (resp) {
                return resp.data;
            });
        };

        return RemindersService;
    }
]);
